import React, { useEffect, useState } from 'react';
import { Search } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Plain "search for broker" input used atop the merged broker list
 * (ConnectBrokerModal / BrokerConnectPanel). Optional `trailing` slot sits
 * to the right (All / Essentials / Pro plan switch).
 */
export default function BrokerSearchInput({
  value,
  onChange,
  placeholder = 'Search for broker...',
  debounceMs = 200,
  trailing = null,
}) {
  const { colors } = useTheme();
  const [text, setText] = useState(value || '');

  useEffect(() => {
    const handle = setTimeout(() => onChange(text), debounceMs);
    return () => clearTimeout(handle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, debounceMs]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 20,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ position: 'relative', flex: '1 1 180px', minWidth: 0 }}>
        <Search
          size={15}
          style={{
            position: 'absolute',
            top: '50%',
            left: 14,
            transform: 'translateY(-50%)',
            color: colors.textMuted,
            pointerEvents: 'none',
          }}
          aria-hidden
        />
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder}
          aria-label="Search for broker"
          style={{
            width: '100%',
            background: colors.bgPrimary,
            border: `1px solid ${colors.border}`,
            borderRadius: 10,
            padding: '10px 14px 10px 38px',
            fontSize: 14,
            color: colors.text,
            outline: 'none',
          }}
        />
        <style>{`
          input[aria-label="Search for broker"]::placeholder {
            color: #ffffff;
            opacity: 0.55;
          }
        `}</style>
      </div>
      {trailing}
    </div>
  );
}
